export const RatingData = [
  {
    rowData: "Number of contests ",
    style1: "border-2 border-r-0",
    style2: "font-semibold border-2",
  },
  {
    rowData: "Best rank ",
    style1: "border-l-2",
    style2: "font-semibold text-green-500 border-x-2",
  },
  {
    rowData: "Worst rank ",
    style1: "border-2 border-r-0",
    style2: "font-semibold text-red-600 border-2",
  },
  {
    rowData: "Maxing rating increase ",
    style1: "border-l-2",
    style2: "font-semibold text-green-500 border-x-2",
  },
  {
    rowData: "Maxing rating decrease ",
    style1: "border-2 border-r-0",
    style2: "font-semibold text-red-600 border-2",
  },
];
